module.exports = __webpack_public_path__ + "static/tech-Icon-curve-b15026385a35bd32cdba8ce69ec89508.png";